import { Component } from '@angular/core';

@Component({
  selector: 'app-accountability',
  templateUrl: './accountability.component.html',
  styleUrls: ['./accountability.component.sass']
})
export class AccountabilityComponent {
  download() {
    let link = document.createElement("a");
    link.download = "plano_de_acoes_comdica_2024.docx";
    link.href = "assets/files/plano_de_acoes_comdica_2024.docx";
    link.click();
  }
}
